<h1 mat-dialog-title class="dialog-title">
  <span class="dialog-title-text">
    {{ title }}
    <span class="dialog-title-sub">
      <span class="subject-name">{{ data.name }}</span>
      @if (loaded && revisionsCount > 0) {
        <span class="dot">·</span>
        <span class="revision-count">{{ revisionsCount }} revision{{ revisionsCount === 1 ? '' : 's' }}</span>
      }
    </span>
  </span>
</h1>

<mat-dialog-content class="dialog-body">
  @if (loaded) {
    @if (revisions.length === 0) {
      <p class="empty">No revisions on record.</p>
    } @else {
      <div class="audit-list">
        @for (revision of revisions; track revision.id) {
          <div class="audit-entry" [class.expanded]="isExpanded(revision)">
            <button
              type="button"
              class="audit-entry-header"
              (click)="toggle(revision)"
              [attr.aria-expanded]="isExpanded(revision)"
            >
              <span class="audit-reason" [ngClass]="revision.reasonClass">{{ revision.reasonLabel }}</span>
              <span class="audit-entry-meta">
                <span class="audit-when">{{ revision.createdAt }}</span>
                @if (revision.isLatest) {
                  <span class="audit-latest-badge">latest</span>
                }
              </span>
              <mat-icon class="audit-toggle-icon" aria-hidden="true">
                {{ isExpanded(revision) ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </button>
            @if (isExpanded(revision)) {
              <div class="audit-entry-summary">{{ revision.summary }}</div>
              @if (revision.reasonDetail) {
                <div class="audit-entry-diff">
                  <div class="diff-row">
                    <span class="diff-label">Note</span>
                    <span class="diff-value">{{ revision.reasonDetail }}</span>
                  </div>
                </div>
              }
            }
          </div>
        }
      </div>

      <p class="mat-hint audit-footer-hint">
        Every save creates a new revision (append-only). The latest revision is what applies at
        output-generation. Deleted sets stay in history for reference; restoring isn't supported in
        v1 — recreate a new set with the same shape if needed.
      </p>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="actions">
  <button mat-stroked-button type="button" (click)="close()">Close</button>
</mat-dialog-actions>
